import React, { useState, useEffect, useContext } from "react";

import Table from "../../common/Table";

import { Link } from "react-router-dom";

import db from "../../../services/query";
import { HalfYearContext } from "../../../contexts/halfYearContext";

const ProjectsIncomes = ({halfYearId}) => {
  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    { path: "name", label: "نام(فارسی)" },
    { path: "budget", label: "بودجه" },
    { path: "received", label: "دریافت شده" },
    { path: "balance", label: "بیلانس" },
    { path: "option" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `revenues/types/2/accounts?halfYearId=${halfYearId || halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return <Table data={data} columns={columns} />;
};

export default ProjectsIncomes;
